module.exports = __webpack_public_path__ + "img/chat_a.da5026ab.png";